<script>
  import MapTool from "./MapTool.svelte";
  import { FontsUrban } from "@urbaninstitute/dataviz-components";
  import state_data from "$data/map/data_fips_wide.csv";
  import config_data from "$data/map/config.csv";
</script>

<svelte:options customElement="map-tool" />

<FontsUrban />
<MapTool
  data={state_data}
  tableData={state_data}
  configData={config_data}
  mapType="hex"
  featureOption="noDC"
  showStateSummary="false"
  dropdownLabel=""
  hideDropdown="true"
  tablePlaceholderLabel="Select a state"
/>
